import DapDSTableCell from './table-cell.component'

export * from './table-cell.component'
export default DapDSTableCell

DapDSTableCell.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-table-cell': DapDSTableCell
  }
}
